export const REALTIME_CONNECT_TOKEN_API = 'idwell-api/realtime/connect/'

export const CENTRIFUGO_WS_PATH = `/centrifugo/connection/websocket`

export const CENTRIFUGE_LOG_PREFIX = '[Centrifuge]'

/*
 * Window for the *initial* connection to succeed. The SDK retries with its own
 * backoff inside this window, so a transient blip at startup self-heals; only
 * if nothing connects within it do we stop the client (see `useCentrifuge`).
 */
export const CENTRIFUGE_INITIAL_CONNECT_TIMEOUT_MS = 30000
